import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { Quote, QuoteDeliveryInput, QuoteGlobalDiscount, QuoteItem } from '../types/quote.type';
import { QuoteTypes } from '../types/quote-type.type';
import { QUOTES_API_PATHS } from '../constants/quotes-paths.constants';

export type CreateQuoteInput = {
  organizationId: string;
  items: QuoteItem[];
  delivery: QuoteDeliveryInput;
  validUntil: string;
  globalDiscount?: QuoteGlobalDiscount;
  conditions?: string;
};

type UseCreateQuoteResult = {
  createQuote: (input: CreateQuoteInput) => Promise<Quote | null>;
  isSubmitting: boolean;
};

export function useCreateQuote(): UseCreateQuoteResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const createQuote = async (input: CreateQuoteInput): Promise<Quote | null> => {
    setIsSubmitting(true);

    try {
      const createdQuote = await HttpClient.post<Quote>(QUOTES_API_PATHS.CREATE, {
        type: QuoteTypes.ORGANIZATION,
        ...input,
      });

      enqueueSnackbar('Devis créé', { variant: 'success' });
      return createdQuote;
    } catch (error) {
      enqueueSnackbar(
        extractApiErrorMessage(error, 'Une erreur est survenue lors de la création du devis'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { createQuote, isSubmitting };
}
